/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1591
 */

require(/* 442 */"./1581/442/index")("search")
